import { Search } from "lucide-react";
import { cn } from "@/components/ui/cn";
import { langPath, type Lang } from "@/lib/i18n";

/**
 * THE search box — one component for every doorway into /search (topbar chrome,
 * the results page itself), so the affordance and the GET contract can't drift.
 * A plain form, deliberately no client JS: Enter navigates to /search?q=…,
 * which works before hydration and for no-JS visitors alike.
 */
export function SearchForm({
  lang,
  placeholder,
  defaultValue = "",
  size = "compact",
  className,
}: {
  lang: Lang;
  placeholder: string;
  defaultValue?: string;
  /** compact = topbar chrome (h-9, text-sm) · large = the search page hero. */
  size?: "compact" | "large";
  className?: string;
}) {
  const large = size === "large";
  return (
    <form action={langPath(lang, "/search")} className={className}>
      <div
        className={cn(
          "border-light-gray focus-within:border-teal flex items-center rounded-full border bg-white transition-colors",
          large ? "h-12 gap-3 px-5 shadow-sm" : "h-9 gap-2.5 px-4",
        )}
      >
        <Search className={cn("text-mid-gray shrink-0", large ? "size-5" : "size-4")} aria-hidden />
        <input
          type="search"
          name="q"
          defaultValue={defaultValue}
          placeholder={placeholder}
          aria-label={placeholder}
          className={cn(
            // focus-visible:shadow-none — the wrapper's focus-within:border-teal
            // is the focus affordance; the global :focus-visible box-shadow ring
            // (globals.css) draws a hard rectangle inside the rounded shell.
            "text-foreground placeholder:text-mid-gray w-full bg-transparent outline-none focus-visible:shadow-none",
            !large && "text-sm",
          )}
        />
      </div>
    </form>
  );
}
